<template>
<div style="height: 94%;overflow: auto;position: absolute;width: 100%;">
    <table class="table users-basic-info-table mt-4" ref="fadeWhenModelOpen" style="background: transparent">
      <tbody>
        <tr style="#bbb">
          <td class="key-div p-2 align-middle" style="width: 20%">
          <input type="radio" id="global" value="global" class="bg-transparent border rounded text-light bigger-checkboxes" v-model="userRetrieval.retrieval_type" @change="updateRetrieve()" name="retrieve"/>
          </td>
          <td class="value-div d-block m-0 p-2" style="width: 80%">
            <label for="global" style="position: relative;bottom: -2px;margin-bottom:0px">{{$t('Global Retrieve Path')}}</label>
            <div class="config-desc">
                    {{$t('retrieve path is taken from Settings → System → Retrieve settings')}}.
                    </div>
          </td>
        </tr>
        <tr style="#bbb">
          <td class="key-div p-2 align-middle" style="width: 20%">
            <input type="radio" id="group"  value="group" class="bg-transparent border rounded text-light bigger-checkboxes" v-model="userRetrieval.retrieval_type" @change="updateRetrieve()" name="retrieve"/>
          </td>
          <td class="value-div d-block m-0 p-2" style="width: 80%">
            <label for="group" style="position: relative;bottom: -2px;margin-bottom:0px">{{$t('Group Retrieve Path')}}</label>
          <div class="config-desc">
                    {{$t('Retrieve path taken from selected group retrieve path Settings → User → Groups')}}.
                    </div>
          </td>
        </tr>
        <tr v-if="(isGroups || userRetrieval.retrieval_type == 'group') && !newUser">
            <td></td>
            <td>
              <div class="w-50 border rounded" style="height:150px;padding-inline-start: 7px;overflow: auto;padding-top: 4px;">
                  <div v-for="group in groups" :key="group._id" class="w-100" style="text-align:start">
                    <input type="radio" :value="group._id" class="bg-transparent border rounded text-light bigger-checkboxes" name="group" @input="updateUserGroup($event)" v-model="userRetrieval.group_id"/>
                    <label style="margin-inline-start: 4px;position: relative;bottom: 5px;color:#aeaeae">{{group.group_name}}</label>
                  </div>
              </div>
            </td>
        </tr>
        <tr style="#bbb">
          <td class="key-div p-2 align-middle" style="width: 20%">
          <input type="radio" id="user" value="user" class="bg-transparent border rounded text-light bigger-checkboxes" v-model="userRetrieval.retrieval_type" @change="updateRetrieve()" name="retrieve"/>
          </td>
          <td class="value-div d-flex m-0 p-2" style="width: 80%">
            <label for="user" style="position: relative;bottom: -2px;margin-bottom:0px">{{$t('Configure Retrieve Path')}}</label>
          </td>
        </tr>
        <tr v-if="isConfigureRetrievePath || userRetrieval.retrieval_type == 'user'">
            <td></td>
            <td class="float-left w-100">
                <div class="d-inline-flex w-100 float-left mb-4">
                  <label style="width:11%;text-align:end;line-height: 22px;position: relative;
    inset-inline-start:5px;" class="text-color">Retrieve Path</label>
                  <div style="display:inline-block;text-align: initial;">
                    <input type="text" v-model="userRetrieval.path" v-if="userRetrieval.path != undefined && userRetrieval.path.length" :style="{width:((userRetrieval.path.length+1)*8) + 'px'}" class="rounded text-light non-editable-field text-light ml-3 pl-2" placeholder="select retrieve path from browse"/>
                    <span v-else class="empty-field-text-styles ml-4 mr-2">NONE</span>
                    <browse-icon v-on:click.native="openAddBinsBrowser()" style="height:26px;margin-inline-start:3px;position: relative;bottom: 5px;"></browse-icon>
                    <div class="config-desc ml-4">
                        Selecting this value, user can have own retrieve path.
                    </div>
                  </div>
              </div>
              <div class="d-inline-flex w-100">
                <label style="width:23%;text-align:end" class="text-color">{{$t('Retrieve With')}}</label>
                <ul class="d-inline-block float-left pl-0" style="list-style-type:none">
                  <li class="d-inline-block flat-left w-100 ml-3" style="margin-bottom:10px">
                    <div class="custom-control w-100 custom-switch d-inline-flex">
                        <input
                            v-model="userRetrieval.category_structure"
                            v-on:click="updateRetrieve()"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch1"
                            :checked='userRetrieval.category_structure'/>
                        <label class="custom-control-label" for="customSwitch1">{{$t('Catalog Folder Structure')}}</label>
                    </div>
                    <div class="config-desc">
                    On file retrieve , file catalog structure created at retrieve path.
                    </div>
                  </li>
                  <li class="d-inline-block flat-left w-100 ml-3">
                    <div class="custom-control w-100 custom-switch d-inline-flex">
                    <input
                            v-model="userRetrieval.date_structure"
                            v-on:click="updateRetrieve()"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch2"
                            :checked='userRetrieval.date_structure'/>
                      <label class="custom-control-label" for="customSwitch2">{{$t('Date Folder Structure')}}</label>
                      </div>
                    <div class="config-desc">
                      On file retrieve, todays date folder structure created at retrieve path.
                      <div><b>{{$t('Example')}}:</b>  If default retrieve path set as “Retrieve“, and today's date is 01 Jan 2000, then file’s retrieve path will be <b>Share://Retrieve/Jan-2000/01-01-2020</b>.</div>
                    </div>
                  </li>
                </ul>
              </div>
            </td>
        </tr>
      </tbody>
    </table>
    <bins-browse-modal
      v-if="isModalVisible"
      :workspaceList="browseWorkspaceList"
      :enableAssetMultiSelect="false"
      @close="closeModal"
      @handleFilesBrowse="selectedBinPath"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
      :parentPreSelectedPathIds="[userRetrieval.path]"
    ></bins-browse-modal>
    </div>
</template>

<script>
import fileBrowseModel from "../files/filesBrowse.vue";
import browseIcon from "../core/InlineBrowseField.vue";
import {mapActions,mapMutations,mapGetters} from "vuex";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
export default {
  props: ["selectedUserID","newUser","selectedUserInfo"],
    data(){
        return{
            isGroups:false,
            isConfigureRetrievePath:false,
            isModalVisible: false,
            retrieveType:null,
            catalogStructure:false,
            dateStructure: false,
            userRetrieval: {},
            groups:[],
            browseWorkspaceList:[Constants.WORKSPACE_BINS],
        }
    },
    components:{
      "browse-icon" : browseIcon,
      "bins-browse-modal": fileBrowseModel,
    },
    methods:{
        toggleIsGroups(){
            this.isGroups = true;
            this.isConfigureRetrievePath = false
        },

        toggleConfigureRetrievePath(){
            this.isConfigureRetrievePath = true
            this.isGroups = false;
        },

        openAddBinsBrowser(){
          this.isModalVisible = true;
          this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },

        isThisChecked(){
          this.isGroups = true;
        },

        updateUserGroup(e){
          this.userRetrieval.group_id = e.target.value;
          this.updateRetrieve();
        },
        selectedBinPath(folderInfoList) {
          if(folderInfoList && folderInfoList.length > 0){
            this.userRetrieval.path = folderInfoList[0].path;
            this.updateRetrieve()
            this.closeModal();
          }else{
            console.log("Failed to update the browsed folder path:",folderInfoList)
          }
        },
        closeModal() {
              this.isModalVisible = false;
              this.$refs.fadeWhenModelOpen.style.opacity = 1;
        },
        getUserRetrieval(){
          return this.userRetrieval;
        },
        updateRetrieve(){
          setTimeout(() => {
            let retrieveList = this.userRetrieval;
            if(retrieveList.retrieval_type == "user"){
              if(retrieveList.path.length == 0 && retrieveList.path != undefined && retrieveList != undefined){
                return false;
              }
            }
            if(retrieveList.retrieval_type == "group" && retrieveList.group_id != undefined && retrieveList != undefined){
              if(retrieveList.group_id.length == 0){
                return false;
              }
            }
            if(this.newUser){
              this.userRetrieval = retrieveList;
              return
            }
            let payload = {};
            payload.access_control = {retrieval:retrieveList}
            payload.params = { user_id: this.selectedUserID };
            this.updateExistingUser(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              if (data.message.includes("Failed")) {
                this.$toast.warning(data.message);
              } else {
                this.refreshRetrieveSettings()
                if(this.getLoggedInUserId() != this.selectedUserID){
                  this.$toast.success(data.message);
                }
              }
            } else {
              this.$toast.error(data.message);
            }
          });
          }, 1000);
        },
        getUserGroupsList(){
          let payload = {};
          payload.params = {user_id: this.selectedUserID};
          this.getAllUserGroupsFromServer(payload).then((data)=>{
                this.groups = data.user_groups;
        });
        },
        refreshRetrieveSettings(){
          if(typeof(this.selectedUserID) != "undefined"){
              if(this.selectedUserInfo && 'access_control' in this.selectedUserInfo){
                this.userRetrieval = this.selectedUserInfo.access_control.retrieval;
              }
          }
        },

        updateUserRetreivePath(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          let messageData = notification.message;
          let userRetreiveData = messageData.access_control.retrieval;
          this.userRetrieval.retrieval_type = userRetreiveData.retrieval_type;
          this.userRetrieval.path = userRetreiveData.path;
          this.userRetrieval.category_structure = userRetreiveData.category_structure;
          this.userRetrieval.date_structure = userRetreiveData.date_structure;
        },
    ...mapActions("users",["getUserInfoFromServer","updateExistingUser","checkUserLoginStatus"]),
    ...mapActions("userGroups",["getAllUserGroupsFromServer"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapGetters("users",["getLoggedInUserId"])
      },
    created(){ 
        if(!this.newUser){
          this.refreshRetrieveSettings();
        }

        this.getUserGroupsList();

        this.addWSEventListener({eventname:Constants.userUpdatedNotification, callback:this.updateUserRetreivePath, parent:"ConfigureRetrieve"});
    },
    beforeDestroy(){
      this.removeWSEventListener({eventname:Constants.userUpdatedNotification, callback:this.updateUserRetreivePath, parent:"ConfigureRetrieve"});
    }
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;


.config-desc{
  color: $dull-text-color;
}

.text-color{
  color:$dull-text-color;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}


input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid #909090 !important;

}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}


.border {
    border: $border-color!important;
}

.heightSet{
  overflow: auto;
  position: absolute;
  width: 100%;
  // height:calc(100%-130px)
}
.hideShowIcons{
    position: absolute;
    inset-inline-start:0px;
    top: -2%;
    width: 22px;
    height: 21px;
}
.bigger-checkboxes {
  height: 30px;
  width: 20px;
  position:relative;
}

.field-description {
  font-size: 11px;
  color: $dull-text-color;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

.comm-input-field-style{
    background: $primary-background!important;
    width: 50% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.non-editable-field{
    border: none !important;
    pointer-events: none;
    cursor: default;
    position: relative;
    bottom: 4px;
}

.config-desc{
  width: 100%;
  text-align: initial;
}

.empty-field-text-styles{
  color:$none-text-color;
}
</style>